import React from 'react';
import { message, Button } from 'antd';
import LeoforceLogoIcon from '../../Icons';
import './SchedularHeader.scss';

function SchedularHeader({ showCalendar }) {
  async function copyToClipBoard() {
    try {
      await navigator.clipboard.writeText(window.location.href);
      message.config({
        maxCount: 1,
      });
      message.success('Link copied to clipboard');
    } catch (err) {
      message.error('Failed to copy link to clipboard');
    }
  }

  return (
    <div className="candidate-schedular-header">
      <div className="leoforce-logo">
        <LeoforceLogoIcon />
        <div>Leoforce</div>
      </div>
      {showCalendar ? (
        <Button className="copy-link-button" onClick={copyToClipBoard} type="primary">
          Copy Link
        </Button>
      ) : null}
    </div>
  );
}

export default SchedularHeader;
